<ui-control-field
  [label]="label()"
  [isRequired]="isRequired()"
  [error]="error()">
  <p-inputMask
    mask="99-999"
    [id]="id()"
    [placeholder]="placeholder()"
    [disabled]="disabled()"
    [ngModel]="value()"
    (onInput)="updateValue($any($event.target).value)"
    (onBlur)="markAsTouched()" />
</ui-control-field>
